import React, { useCallback } from 'react';
import HiConversationDetail from '../HiConversationDetail';
import style from './index.module.scss';
import { useCurrentAddressInfo } from '@/hooks';
import { wrapModalPromise, WrapModalProps, login } from 'utils';
import { IconHiConversationModalIcon } from '@/assets/hi';
interface HiConversationModalProps {
  hiId: string;
  initialText?: string;
}

const HiConversationModal = ({
  hiId,
  initialText,
  hide,
}: HiConversationModalProps & WrapModalProps) => {
  return (
    <>
      <HiConversationDetail
        initialText={initialText}
        addr={hiId}
        hideOperationMenu
        hideFollowTip
        messageInputMinRow={3}
        containerClassName={style.hiConversationContainer}
        openInModal
      />
      <IconHiConversationModalIcon className={style.modalLogo} />
    </>
  );
};

const openHiConversationModal = (props: HiConversationModalProps) => {
  wrapModalPromise<HiConversationModalProps>(HiConversationModal, {
    containerClassName: style.modal,
    className: style.modalWrapper,
  })(props);
};

export const useHiConversationModal = () => {
  const { address } = useCurrentAddressInfo();
  const openHiModal = useCallback(
    (props: HiConversationModalProps) => {
      if (!address) {
        login();
        return;
      }
      openHiConversationModal(props);
    },
    [address],
  );

  return {
    openHiModal,
  };
};
